export default __webpack_public_path__ + "static/media/tipo-pagamento-cielo.2cc4ca78.png";